import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class BroadcastScheduleStore extends LocalModel {
    constructor() {
        super('broadcastDaySchedule', {
            namePlural: 'broadcastDaySchedules',
            namePluralReal: 'broadcastschedules',
            sort: '-date',
            limit: 100,
            api: {
                search: {
                    url: '/api/broadcastschedules/',
                    params: {
                        limit: 100,
                        sort: '-date',
                    },
                },
                load: {
                    url: '/api/broadcastschedules/',
                    params: {},
                },
                save: {
                    url: '/api/broadcastschedules/',
                    params: {},
                },
                delete: {
                    url: '/api/broadcastschedules/',
                    params: {},
                },
            },
        });
    }

    @observable broadcastDaySchedule = {};

    @observable broadcastDaySchedules = [];

    @observable selectedScheduleId = null;

    @action
    setSelectedSchedule(scheduleId) {
        this.selectedScheduleId = scheduleId;
    }

    async loadSchedules(params = {}) {
        const response = await util.fetchApi('/api/broadcastschedules/', { method: 'GET' }, params);
        if (response.status === 200) {
            this.updateKeyValue('broadcastDaySchedules', response.data || []);
            return response.data;
        }
        return [];
    }

    async approveSchedule(id) {
        const response = await util.fetchApi(`/api/broadcastschedules/${id}/approve`, { method: 'POST' }, {});
        return response;
    }

    async exportCsv(id, format) {
        const jwtToken = util.getJwtToken();
        const params = format ? `?format=${format}&jwtToken=${jwtToken}` : `?jwtToken=${jwtToken}`;
        window.location.href = `${util.getApiServer()}/api/broadcastschedules/${id}/csv${params}`;
    }
}

const store = new BroadcastScheduleStore();
export default store;
